import { useEffect, useRef, useState } from "react"

export function useDragDropOverlay() {
  const [isDragActive, setIsDragActive] = useState(false)
  const dragCounterRef = useRef(0)

  useEffect(() => {
    const onEnter = (e: DragEvent) => {
      if (!e.dataTransfer?.types.includes("Files")) return
      dragCounterRef.current++
      setIsDragActive(true)
    }
    const onLeave = () => {
      dragCounterRef.current = Math.max(0, dragCounterRef.current - 1)
      if (dragCounterRef.current === 0) setIsDragActive(false)
    }
    // A file let go OUTSIDE the overlay (a container-scoped overlay leaves the
    // app chrome uncovered) must not fall through to the browser default,
    // which navigates the tab to the dropped file. Cancelling dragover is what
    // makes the window a valid drop target so `drop` fires at all.
    const onOver = (e: DragEvent) => {
      if (e.dataTransfer?.types.includes("Files")) e.preventDefault()
    }
    const onDrop = (e: DragEvent) => {
      if (e.dataTransfer?.types.includes("Files")) e.preventDefault()
      dragCounterRef.current = 0
      setIsDragActive(false)
    }
    window.addEventListener("dragenter", onEnter)
    window.addEventListener("dragleave", onLeave)
    window.addEventListener("dragover", onOver)
    window.addEventListener("drop", onDrop)
    return () => {
      window.removeEventListener("dragenter", onEnter)
      window.removeEventListener("dragleave", onLeave)
      window.removeEventListener("dragover", onOver)
      window.removeEventListener("drop", onDrop)
    }
  }, [])

  function dismiss() {
    dragCounterRef.current = 0
    setIsDragActive(false)
  }

  return { isDragActive, dismiss }
}
